import { useStatsigClient } from '@statsig/react-bindings';

/** Statsig gate controlling whether Vio's Top Trends section is shown. */
export const GUEST_JOURNEY_VIO_GATE = 'guest-journey-vio';

/** True when Vio's Top Trends should be shown (per the Statsig gate). */
export const useGuestJourneyVioGate = (): boolean => {
  const { client } = useStatsigClient();
  return client.checkGate(GUEST_JOURNEY_VIO_GATE);
};
